// extracted by mini-css-extract-plugin
export var cardTitle = "_he-1";
export var commentBubble = "_he-e";
export var commentForm = "_he-a";
export var commentInput = "_he-b";
export var commentLabel = "_he-d";
export var commentPrompt = "_he-9";
export var csatCard = "_he-0";
export var feedbackSection = "_he-7";
export var starDisabled = "_he-6";
export var starEmpty = "_he-5";
export var starFilled = "_he-4";
export var starWrapper = "_he-3";
export var starsContainer = "_he-2";
export var submittedComment = "_he-c";
export var thankYouText = "_he-8";